import React from 'react';
// import { Button } from '@material-ui/core';
import Button from '@mui/material/Button';
import { useFormikContext } from 'formik';
import useEnterKeyListener from './EnterKeyListener';

const SubmitButtonWrapper = ({
  children,
  ...otherProps
}) => {
  const { submitForm } = useFormikContext();

  useEnterKeyListener({
    querySelectorToExecuteClick: "#submitButton"
  });
  const handleSubmit = () => {
    submitForm();
  }

  const configButton = {
    variant: 'contained',
    color: 'primary',
    fullWidth: true,
    onClick: handleSubmit
  }

  return (
    <Button id="submitButton"
      {...configButton}
    // fullWidth
    >
      {children}
    </Button>
  );
};

export default SubmitButtonWrapper;